import React from "react";
import Signup from './components/Signup';
import "./App.css";
import { useQuery, gql } from "@apollo/client";
import { Route, Routes } from "react-router-dom";
import Home from "./components/home";
import { ThemeProvider } from "@material-ui/core";
import { createTheme } from "@mui/material/styles";
import CssBaseline from "@material-ui/core/CssBaseline";

const theme = createTheme({
  palette: {
    primary: {
      main: "#000000",
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<Signup />} /> {/* Add a route for Signup */}
      </Routes>
    </ThemeProvider>
  );
};

export default App;
